import { ResourceLocation } from '@/generated/data.schemas';

export enum AppSolutionBuilderStep {
	Segment = 'segment',
	Application = 'application',
	SubApplication = 'subApplication',
	Specifications = 'specifications',
	FilterUnit = 'filterUnit',
	Configuration = 'configuration',
	Additional = 'additional',
	Summary = 'summary',
}

export interface StepItem {
	step: AppSolutionBuilderStep;
	text: string;
	progressText: string;
	current: boolean;
	route?: ResourceLocation;
}

export interface ActiveValueItem {
	id: string;
	label: string;
	value?: string;
}

export interface OverviewConfigSection {
	label?: string;
	activeItem?: React.ReactNode;
	onEdit?: () => void;
	hideEdit?: boolean;
}

export interface OverviewConfigProps {
	step: AppSolutionBuilderStep;
	headline?: string;
	activeItem?: React.ReactNode;
	sections?: OverviewConfigSection[];
}

export interface ConfigurationProductsProps {
	variantId?: string;
	inserts?: string;
	addOns?: string;
}

export type AdditionalType = { id: string; quantity: number };
export interface AdditionalsPayload {
	spareParts?: AdditionalType[];
	accessories?: AdditionalType[];
}

export type InstalledEquipment = {
	pumpType: string;
	insertType: string;
	name?: string;
	insertQuantity?: number;
	insertProductId?: string;
	id?: string | null;
	skuNo?: number | string | null;
};
